// NATIVE

// INSTALLED
import { Route, Routes, useLocation } from 'react-router-dom';

// CUSTOM
import { LoginPage } from '../pages/LoginPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';

export const PublicRoutes = () => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/*" element={<LoginPage />} />
    </Routes>
  );
};
